const LoyaltyModule = () => import('./LoyaltyModule.vue')
const BenchmarkPrices = () => import('./views/BenchmarkPricesIndex.vue')

export const loyaltyRoute = {
  path: '/loyalty',
  component: LoyaltyModule,
  meta: {
    title: 'Loyalty',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'benchmark-prices',
      name: 'loyalty.benchmarkPrices',
      meta: {
        permission: 'loyalty.view',
      },
      component: BenchmarkPrices,
    }
  ],
}
